import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import InfoBox from 'components/Shared/InfoBox'
import Input from 'components/Shared/Input'
import {
  useCampaignSetup,
  useCampaignSetupDispatch,
} from 'components/Recommendations/Campaign/Context/CampaignSetupContext'

export default function Beneficiary({ recommendation, disabled = false }) {
  const { t } = useTranslation()
  const { setup } = useCampaignSetup()
  const { updateDsaFields } = useCampaignSetupDispatch()

  const beneficiary = setup?.dsa_beneficiary ?? recommendation

  return (
    <div className="field-wrapper">
      <InfoBox content="Tips.Recommendations.beneficiary">
        <span>{t('Recommendations.summary.advancedSettings.beneficiary.title')}</span>
      </InfoBox>

      <Input
        value={beneficiary}
        onChange={(e) => {
          const value = e.target.value
          updateDsaFields({ dsa_beneficiary: value })
        }}
        wrapperClass="mb-0 w-100"
        disabled={disabled}
      />
    </div>
  )
}

Beneficiary.propTypes = {
  recommendation: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}